import { Controller } from "@hotwired/stimulus"

// A touch-friendly signature pad. Each completed stroke serializes the pad
// into the hidden input so the form always carries the latest signature.
export default class extends Controller {
  static targets = ["canvas", "input", "placeholder"]

  connect() {
    this.drawing = false
    this.hasInk = false
    this.resize()
    this.resizeHandler = () => this.resize()
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
  }

  resize() {
    const canvas = this.canvasTarget
    const width = canvas.parentElement.clientWidth
    if (width === 0) return
    // Resizing a canvas erases it — skip when nothing changed so a late
    // resize event can't wipe a signature already in progress.
    if (canvas.width === width && canvas.height === 160) return
    canvas.width = width
    canvas.height = 160
    const ctx = canvas.getContext("2d")
    ctx.fillStyle = "#FFFFFF"
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    this.hasInk = false
    if (this.hasInputTarget) this.inputTarget.value = ""
  }

  start(event) {
    event.preventDefault()
    this.drawing = true
    const ctx = this.canvasTarget.getContext("2d")
    ctx.strokeStyle = "#111827"
    ctx.lineWidth = 2.5
    ctx.lineCap = "round"
    ctx.beginPath()
    const [x, y] = this.point(event)
    ctx.moveTo(x, y)
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
  }

  move(event) {
    if (!this.drawing) return
    event.preventDefault()
    const ctx = this.canvasTarget.getContext("2d")
    const [x, y] = this.point(event)
    ctx.lineTo(x, y)
    ctx.stroke()
    this.hasInk = true
  }

  end() {
    if (!this.drawing) return
    this.drawing = false
    if (this.hasInk && this.hasInputTarget) {
      this.inputTarget.value = this.canvasTarget.toDataURL("image/png")
    }
  }

  clear() {
    this.resize()
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("hidden")
  }

  point(event) {
    const rect = this.canvasTarget.getBoundingClientRect()
    return [event.clientX - rect.left, event.clientY - rect.top]
  }
}
